export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/violin.6d97eb3.svg";